import React, { useContext, useEffect, useState } from "react";
import { PulseLoader } from "react-spinners";
import CampaignContext from "../../../../contexts/CampaignContext";
import UserContext from "../../../../contexts/UserContext";
import restService from "../../../../restService";
import Donut from "../../../components/Charts/donut";
import { regions } from "../../management/editStation";

const formattedRegions = regions.map((region) => ({
  label: region,
  value: region,
}));

const BrandMetrics = ({ brands, state }) => {
  const charts = ["Bar", "Pie"];
  const [currentChart, setCurrentChart] = useState("Bar");
  const [campaign] = useContext(CampaignContext);
  const [user] = useContext(UserContext);
  const [data, setData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [tempSearchList, setTempSearchList] = useState([
    formattedRegions[0].value,
  ]);
  const [errorMessage, setErrorMessage] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const [performancePerBrandData, setPerformancePerBrandData] = useState([]);
  const [performancePerBrandCategories, setPerformancePerBrandCategories] =
    useState([]);
  const [showComparison, setShowComparison] = useState(false);
  const [searchTags, setSearchTags] = useState([]);

  // const [state, setState] = useState([
  //   {
  //     startDate: addDays(new Date(), -7).setHours(0, 0, 0, 0),
  //     endDate: new Date().setHours(23, 59, 59, 0),
  //     key: "selection",
  //   },
  // ]);
  const [isLoading, setIsLoading] = useState(false);

  const handleSearch = async (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    try {
      const {
        data: { data },
      } = await restService.Insights.searchLocationInsights(campaign.id, value);

      setSearchTags(data);
    } catch (error) {
      console.log(error);
    }
  };

  const [options, setOptions] = useState([]);

  useEffect(() => {
    fetchSKUPerformance();
  }, [state]);

  const fetchSKUPerformance = async () => {
    try {
      const {
        data: { data },
      } = await restService.reportBreakdown.productPerformance({
        campaignId: campaign.id,
        startDate: new Date(state[0].startDate).toISOString().slice(0, -5),
        endDate: new Date(state[0].endDate).toISOString().slice(0, -5),
        token: user?.accessToken,
      });

      const modifiedData = (data || []).map((item) => ({
        name: item?.product,
        y: item?.count,
      }));

      setData(modifiedData);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="md:px-0 py-5">
      <div className="bg-white shadow w-full flex flex-col gap-2 py-4 md:px-8 px-4">
        <div className="flex items-center justify-between md:flex-row flex-col gap-3">
          <div className="md:min-w-[30%]  min-w-full"></div>

          {/* <div className="border rounded md:w-auto w-full">
            <DatePicker state={state} setState={setState} />
          </div> */}
        </div>
        {errorMessage ? (
          <p className="text-xs text-[#ff0000]">{errorMessage}</p>
        ) : (
          <div className="flex items-start"></div>
        )}

        <div className="w-full flex items-center justify-center mt-5">
          <h3 className="font-[500] md:text-xl text-lg text-center">
            <span>
              <span>Brands Performance</span>
            </span>
          </h3>
        </div>

        {isLoading ? (
          <div className="min-h-[50vh] flex item-center justify-center">
            <PulseLoader color="#FF6A3A" />
          </div>
        ) : (
          <>
            {data?.length < 1 ? (
              <div className="w-full flex justify-center mt-20 mb-20 ">
                <img
                  src={require("../../../../assets/images/noData.svg")}
                  alt=""
                />
              </div>
            ) : (
              <div className="mt-11">
                <Donut series={data} />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default BrandMetrics;
